import React, { useState, useEffect } from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ProductSlider from "./components/ProductSlider";
import About from "./components/About";
import Products from "./components/Products";
import Products2 from "./components/Products2";
import ShadeCards from "./components/ShadeCards";
import ColorSamples from "./components/ColorSamples";
import PaintVisualizer from "./components/PaintVisualizer";
import PaintCalculator from "./components/PaintCalculator";
import ProductsSection from "./components/ProductsSection";
import Footer from "./components/Footer";
import ScrollToTopButton from "./components/ScrollToTopButton";
import FloatingCartButton from "./components/FloatingCartButton";
// import InstagramEmbed from "./components/InstagramEmbed";
import Loader from "./components/Loader";

// Pages
import Paint from "./pages/paint";
import Estore from "./pages/Estore";
import Aboutus from "./pages/Aboutus";
import Whychooseus from "./pages/Whychooseus";
import Productoverview from "./pages/Productoverview";
import Testimonials from "./pages/Testimonials";
// import ProductDetail from "./components/ProductDetail";
import ProductDetailPage from "./pages/ProductDetailPage";
import CartPage from "./pages/CartPage";
import OrderConfirmPage from "./pages/OrderConfirmPage";
import Success from "./pages/Success";
import PCalculator from "./pages/PCalculator";
import Creator from "./pages/Creator";

function Home() {
  return (
    <>
      <Navbar />
      <Hero />
      <ProductSlider />
      <About />
      <Products />
      <Products2 />
      <ShadeCards />
      <ColorSamples />
      <PaintVisualizer />
      <PaintCalculator />
      <ProductsSection />
      {/* <InstagramEmbed
        urls={[
          "https://www.instagram.com/reel/DQZaFw7DXOS/?utm_source=ig_embed&amp;utm_campaign=loading", 
          "https://www.instagram.com/reel/DQXBDs9DQ7B/?utm_source=ig_embed&amp;utm_campaign=loading", 
          "https://www.instagram.com/reel/DOYpFzOjaAu/?utm_source=ig_embed&amp;utm_campaign=loading"
        ]}
      /> */}
      <Footer />
      <ScrollToTopButton />
    </>
  );
}

// ✅ Component to handle page transitions and show Loader
function PageLoaderWrapper({ children }) {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 500); // Loader duration (1.5s)
    return () => clearTimeout(timer);
  }, [location]);

  return loading ? <Loader /> : children;
}

function App() {
  return (
    <Router>
      <PageLoaderWrapper>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/paint-visualizer" element={<Paint />} />
        <Route path="/e-store" element={<Estore />} />
        <Route path="/paint-calculator" element={<PCalculator />} />
        <Route path="/about-us" element={<Aboutus />} />
        <Route path="/why-choose-us" element={<Whychooseus />} />
        <Route path="/product-overview" element={<Productoverview />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/products/:id" element={<ProductDetailPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/order-confirm" element={<OrderConfirmPage />} />
        <Route path="/success" element={<Success />} />
        <Route path="/creator" element={<Creator />} />
      </Routes>
      <FloatingCartButton />
      </PageLoaderWrapper>
    </Router>
  );
}

export default App;
